import { lazy, Suspense } from 'react'
import { To } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { useFeatures } from 'modules/core/hooks/useFeatures'

import { Folder } from 'modules/documents/hooks/useGetFolders'

const LegacyDataTable = lazy(() => import('./LegacyDataTable'))
const DocumentsDataCollection = lazy(() => import('./DataCollection'))

const LoadingFallback = () => (
  <Box alignItems="center" padding="s64">
    <Spinner />
  </Box>
)

type Props = {
  onNavigationClick: (documentId: string) => void
  folder?: Folder | null
  initialFolder?: Folder | null
  employeeId?: string
  parentRoute?: To
  onDrop: (files: File[]) => void
  multiple?: boolean
  readonly: boolean
  onUpload?: () => void
  isLoading?: boolean
}

const DocumentsDataTable = (props: Props) => {
  const { has_dev_documents_data_collection } = useFeatures(['dev_documents_data_collection'])

  return (
    <Suspense fallback={<LoadingFallback />}>
      {has_dev_documents_data_collection ? (
        <DocumentsDataCollection
          folder={props.folder}
          initialFolder={props.initialFolder}
          employeeId={props.employeeId}
          parentRoute={props.parentRoute}
          onDrop={props.onDrop}
          multiple={props.multiple}
          readonly={props.readonly}
          onUpload={props.onUpload}
          isLoading={props.isLoading}
        />
      ) : (
        <LegacyDataTable {...props} />
      )}
    </Suspense>
  )
}

export default DocumentsDataTable
